import React from 'react';

const FormSelect = ({ label, required, error, register, options, placeholder, className = '', value, onChange, onBlur }) => {
  // If register is provided, use react-hook-form mode
  // Otherwise, use controlled component mode
  const isControlled = !register;

  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <select
        {...(isControlled ? {} : register)}
        value={isControlled ? (value || "") : undefined}
        onChange={isControlled ? onChange : undefined}
        onBlur={isControlled ? onBlur : undefined}
        className="mt-1 block w-full border-2 border-gray-200 rounded-lg px-4 py-3 text-gray-900 transition-all duration-200 group-hover:border-gray-300"
      >
        <option value="">{placeholder}</option>
        {options.map(({ value: optionValue, label: optionLabel }) => (
          <option key={optionValue} value={optionValue}>
            {optionLabel}
          </option>
        ))}
      </select>
      {error && <p className="text-red-500 text-xs mt-1">{error.message || error}</p>}
    </div>
  );
};

export default FormSelect;
